import { render, staticRenderFns } from "./BudgetAlertsComponent.vue?vue&type=template&id=3900fec1&scoped=true"
import script from "./BudgetAlertsComponent.vue?vue&type=script&lang=js"
export * from "./BudgetAlertsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900fec1",
  null
  
)

export default component.exports